// src/routes/ProtectedRoute.jsx
import SidebarLayout from "@/Layout/SidebarLayout";
import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { routePermissions, getFirstAllowedRoute } from "@/constants/routePermissions";
import { usePermissions } from "@/context/PermissionContext";
import LoadingComponent from "@/components/common/LoadingComponent";
import { ChatbotProvider } from "@/context/ChatbotContext";
import FloatingChatbot from "@/components/common/FloatingChatbot";
import { getAccessToken, clearSession } from "@/utils/authSession";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, isLoading } = usePermissions();

  useEffect(() => {
    const token = getAccessToken();

    if (!token) {
      clearSession();
      navigate("/login", { replace: true });
      return;
    }

    if (isLoading) return;

    if (location.pathname === "/") {
      if (!hasPermission("dashboard_view")) {
        const firstRoute = getFirstAllowedRoute(hasPermission);
        if (firstRoute) {
          navigate(firstRoute, { replace: true });
        } else {
          clearSession();
          navigate("/login", { replace: true });
        }
      }
      return;
    }

    const requiredPermission = routePermissions[location.pathname];
    if (requiredPermission && !hasPermission(requiredPermission)) {
      const firstRoute = getFirstAllowedRoute(hasPermission);
      navigate(firstRoute ?? "/login", { replace: true });
    }
  }, [location.pathname, hasPermission, isLoading, navigate]);

  if (isLoading) return <LoadingComponent />;

  if(location.pathname==="/board-pack-mobile"){
   return <Outlet/>
  }

  // ChatbotProvider wraps everything so state persists across route changes.
  // FloatingChatbot is rendered ONCE here — outside SidebarLayout —
  // so route changes inside <Outlet /> do NOT unmount it.
  return (
    <ChatbotProvider>
      <SidebarLayout>
        <Outlet />
      </SidebarLayout>
      <FloatingChatbot />
    </ChatbotProvider>
  );
};

export default ProtectedRoute;